import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=19c6539e&"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js&"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19c6539e')) {
      api.createRecord('19c6539e', component.options)
    } else {
      api.reload('19c6539e', component.options)
    }
    module.hot.accept("./terms-and-conditions.vue?vue&type=template&id=19c6539e&", function () {
      api.rerender('19c6539e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/terms-and-conditions.vue"
export default component.exports